/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { AvForm } from 'availity-reactstrap-validation';
import {
  AddButton,
  Buttons,
  CancelButton,
  DeleteButton,
  IPopUp,
  UpdateButton,
} from '../../../components/Common/iComponents/iPopUp/IpopUp';
import { getRoles } from '../../../store/Roles/actions';
import { getClients } from '../../../store/client/actions';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import  IButtonComponent  from '../../../components/Common/iComponents/iButton/IButton';
import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';
import { Label, FormGroup } from 'reactstrap';

import FormUsersModal from '../../Users/form-Users';
import { transformObjectKey } from '../../../helpers/tools_helper';

const FormUsers = ({
  selectedRow,
  onCreateUser,
  onUpdateUser,
  onDeleteUser,
  onCancel,
}: any) => {
  const dispatch = useDispatch();
  const { roles, CountItems } = useSelector((state: any) => state.Roles);
  const { clients } = useSelector((state: any) => state.clients);
  const [arrayUpdAdd, SetarrayUpdAdd] = useState<any>([]);
  const columsPop = 2;

  const [valueEntities, setValueEntities] = React.useState<any>([]);

  const [form, setForm] = useState({
    USER_NAME: '',
    USER_LAST_NAME: '',
    USER_ACTIVE: false,
    USER_PASSWORD: '',
    COMPANY_ID: '',
    USER_EMAIL: '',
    ROLE_ID: '',
    SUB_ENTITIES: '',
    INNOBOKEY: '',
    NETWORK_ID: '',
  });

  const keyMapping = {
    'USUARIO_NOMBRE': 'USER_NAME',
    'USUARIO_APELLIDO': 'USER_LAST_NAME',
    'USUARIO_PASSWORD': 'USER_PASSWORD',
    'USUARIO_CORREO': 'USER_EMAIL',
    'ROL_ID': 'ROLE_ID',
    'EMPRESA_ID': 'COMPANY_ID',
    'createdAt': 'Created_At',
    'USUARIO_ACTIVO': 'USER_ACTIVE'
  };


  const [flag, setflag] = useState<any>(true);
  const [popUpState, setpopUpState] = useState(false);

  const valuesSizeRolesPagination = [10, 20, 30, 40, 50, 100];
  const [paginationRoles, setPaginationRoles] = useState<any>({
    sizePerPage: valuesSizeRolesPagination[0],
    page: 1,
  });

  const handlePaginationRolesChange = (newState: any) => {
    setPaginationRoles(newState);
  };

  const initialArrayTableRoles = [
    {
      text: 'Id',
      dataField: 'id',
      formatter: (cellContent: any, roles: any) => <>{roles.id}</>,
      hidden: false,
    },
    {
      text: 'Name',
      dataField: 'nombre',
      formatter: (cellContent: any, roles: any) => <>{roles.nombre}</>,
      hidden: false,
    },
  ];

  const initialArrayTableClients = [
    {
      text: 'Id',
      dataField: 'id',
      formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
      hidden: false,
    },
    {
      text: 'Name',
      dataField: 'name',
      formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
      hidden: false,
    },
  ];

  const initialArrayTableNetworkID = [
    {
      text: 'Network ID',
      dataField: 'company',
      formatter: (cellContent: any, clients: any) => <>{clients.company}</>,
      hidden: false,
    },
    {
      text: 'Name',
      dataField: 'name',
      formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
      hidden: false,
    },
  ];

  useEffect(() => {
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
      user = JSON.parse(getAuthUser);
    }
    if (user.ROL_ID !== '19') {
      if (!selectedRow) {
        setForm({
          ...form,
          COMPANY_ID: user.EMPRESA_ID,
          NETWORK_ID: user.NETWORK_ID,
        });
      }
      SetarrayUpdAdd([
        'USER_NAME',
        'USER_LAST_NAME',
        'USER_PASSWORD',
        'USER_EMAIL',
        'INNOBOKEY',
        'NETWORK_ID',
        'Created_At',
        'SUB_ENTITIES',
        'USER_ACTIVE',
      ]);
    } else {
      SetarrayUpdAdd([
        'USER_NAME',
        'USER_LAST_NAME',
        'USER_PASSWORD',
        'USER_EMAIL',
        'ROLE_ID',
        'COMPANY_ID',
        'INNOBOKEY',
        'NETWORK_ID',
        'Created_At',
        'SUB_ENTITIES',
        'USER_ACTIVE',
        
      ]);
    }
  }, []);

  useEffect(() => {
    dispatch(getRoles({ pagination: paginationRoles }));
    if (clients.length === 0) {
      dispatch(getClients({}));
    }
    
    let text = '';
    if (selectedRow) {
      let newArray = [];
      if (selectedRow.SUB_ENTITIES) {
        if (typeof selectedRow.SUB_ENTITIES === "string") {
          newArray = selectedRow.SUB_ENTITIES.trim()
            .split(',')
            .map((item: any) => {
              return {
                label: item,
                value: item,
              };
            });
          const SUB_ENTITIESArray = selectedRow.SUB_ENTITIES.trim().split(',')
          text = '["';
          text = text +
            SUB_ENTITIESArray.map((item: any) => item.trim()).join('","');
          text = text + '"]';
        }

        if (Array.isArray(selectedRow.SUB_ENTITIES)) {
          newArray = selectedRow.SUB_ENTITIES.map((item: any) => {
            return {
              label: item,
              value: item,
            };
          });
          text = '["' + selectedRow.SUB_ENTITIES.map((item: any) => item.trim()).join('","') + '"]' ; 
        }
      }

      selectedRow = transformObjectKey(selectedRow,keyMapping)


      setForm({
        ...selectedRow,
        // La clave actual ya no llega del servidor: vacia = no se cambia. Se escribe solo para poner una nueva.
        USER_PASSWORD: '',
        SUB_ENTITIES: text === '' ? null : `${text}`,
        USER_ACTIVE: selectedRow.USER_ACTIVE === 'true' ? true : false,
      });
      setValueEntities(newArray);
    }
  }, [selectedRow]);

  const itemVals = (val: any, updateVal: any) => {
    for (const property in updateVal) {
      if (property === val) {
        return updateVal[property];
      }
    }
  };

  const renderButtons = () => (
    <Buttons>
      {selectedRow ? (
        <>
          <CancelButton
            className="button"
            onClick={() => onCancel()}
            data-bs-toggle="tooltip"
          >
            <i
              className="bx bx-power-off"
              style={{ fontSize: '2.5em' }}
              data-bs-toggle="tooltip"
            ></i>
          </CancelButton>
          <DeleteButton
            type="button"
            className="btn-delete"
            onClick={() => onDeleteUser(selectedRow.id)}
          >
            <i className="dripicons-trash" style={{ fontSize: '1.7em' }}></i>
          </DeleteButton>
          <UpdateButton
            className="button"
            disabled={flag}
            onClick={() => onUpdateUser(form)}
          >
            <i className="bx bx-sync" style={{ fontSize: '2.5em' }}></i>
          </UpdateButton>
        </>
      ) : (
        <AddButton
          type="submit"
          disabled={flag}
          className="btn"
          onClick={() => {
            onCreateUser(form);
          }}
        >
          <i className="bx bx-user-check" style={{ fontSize: '3.5em' }} />
        </AddButton>
      )}
    </Buttons>
  );

  useEffect(() => {
    const {
      USER_NAME,
      USER_LAST_NAME,
      USER_EMAIL,
      COMPANY_ID,
      USER_PASSWORD,
      NETWORK_ID,
    } = form;
    if (
      USER_NAME !== '' &&
      USER_LAST_NAME !== '' &&
      (USER_PASSWORD !== '' || !!selectedRow) && // al editar, la clave es opcional
      COMPANY_ID !== '' &&
      USER_EMAIL !== '' &&
      // ROLE_ID !== "" &&
      NETWORK_ID !== ''
    ) {
      setflag(false);
    } else {
      setflag(true);
    }
  }, [form]);

  const onChangeHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: e.target.value,
    });
  };

  const onChangeBooleanHandler = (e: any, n: any) => {
    setForm({
      ...form,
      [n]: !form[n as keyof typeof form],
    });
  };

  const onChangeSelectHandler = (n: any, arrayEntities: any, action:number|undefined = undefined) => {
    
    let text = '';
    if (arrayEntities.length !== 0 && (typeof arrayEntities) !== "string") {
      text = text + arrayEntities.map((item: any) => item.label.trim()).join('","');
    } else if ((typeof arrayEntities) === "string" ) {
      text = `${arrayEntities}`
    }
    setForm({
      ...form,
      [n]: `${text}`,
    });
    if (!action) {
      onPopUpState();
    }
  };

  const onChangeSelectorHandler = (n: any, value: any) => {
    setForm({
      ...form,
      [n]: n != "NETWORK_ID" ? String(value.id): String(value.company),
    });
  };

  const onPopUpState = () => {
    setpopUpState(!popUpState);
  };

  return (
    <>
      <div style={{ height: '450px', overflow: 'auto' }}>
        <AvForm
          className="custom-form mt-0"
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
            gridAutoRows: 'minmax(8%, 80px)',
            gridGap: '2%', //distancia de separacion entre los input
            padding: '0',
            marginLeft: '5%',
            marginRight: '5%',
            paddingTop: '2%',
          }}
        >
          {arrayUpdAdd?.map((val: any) => {
            const nameObject = val as keyof typeof form;
            const temp = form[nameObject];
            let valid = temp ? true : false;
            let type = '';
            let activeReadonly = false;
            let nameSelector = '';
            const value = selectedRow ? itemVals(val, selectedRow) : null;

            switch (val) {
              case 'USER_PASSWORD':
                type = 'password';
                break;
              case 'ROLE_ID':
                nameSelector =
                  value || value === null
                    ? roles.filter(
                        (item: any) => Number(item.id) === Number(temp),
                      )[0]?.nombre
                    : '';
                return (
                  <ISelector
                    title={val}
                    value={String(temp)}
                    nameSelector={nameSelector ?? ''}
                    valuesSizePagination={valuesSizeRolesPagination}
                    dataSelector={roles}
                    CountItems={CountItems}
                    initialArrayTable={initialArrayTableRoles}
                    handlePaginationChange={handlePaginationRolesChange}
                    setSelectedRow={onChangeSelectorHandler}
                    onChangeHandler={onChangeHandler}
                  />
                );
              case 'clientId':
              case 'COMPANY_ID':
                nameSelector =
                  value || value === null
                    ? clients.filter(
                        (item: any) => Number(item.id) === Number(temp),
                      )[0]?.name
                    : '';
                return (
                  <ISelector
                    title={val}
                    value={String(temp)}
                    nameSelector={nameSelector ?? ''}
                    valuesSizePagination={valuesSizeRolesPagination}
                    CountItems={CountItems}
                    dataSelector={clients}
                    initialArrayTable={initialArrayTableClients}
                    handlePaginationChange={handlePaginationRolesChange}
                    setSelectedRow={onChangeSelectorHandler}
                    onChangeHandler={onChangeHandler}
                  />
                );
              case 'NETWORK_ID':
                nameSelector =
                  value || value === null
                    ? clients.filter(
                        (item: any) => Number(item.company) === Number(temp),
                      )[0]?.name
                    : '';
                return (
                  <ISelector
                    title={val}
                    value={String(temp)}
                    nameSelector={nameSelector ?? ''}
                    valuesSizePagination={valuesSizeRolesPagination}
                    dataSelector={clients}
                    CountItems={CountItems}
                    initialArrayTable={initialArrayTableNetworkID}
                    handlePaginationChange={handlePaginationRolesChange}
                    setSelectedRow={onChangeSelectorHandler}
                    onChangeHandler={onChangeHandler}
                  />
                );
              case 'INNOBOKEY':
                type = 'text';
                valid = true;
                break;
              case 'USER_ACTIVE':
                return (
                  <FormGroup className="text-center">
                    <div className="text-capitalize">
                      <Label>{val.replace(/_/g, ' ').toLowerCase()}</Label>
                    </div>
                    <Label>
                      <ISwitch
                        title={val}
                        checked={Boolean(form[nameObject])}
                        onChangeBooleanHandler={onChangeBooleanHandler}
                      />
                    </Label>
                  </FormGroup>
                );
              case 'SUB_ENTITIES':
                return(
                  <div className="d-flex justify-content-center align-items-center" >
                    <IButtonComponent
                      className="btn-search"
                      actionOnClick={onPopUpState}
                      label={'Sub Entities'}
                      btnIcon='bx bx-shape-polygon'
                  />
                </div>
                )
                case 'Created_At':
                  activeReadonly = true;
                   if(temp){
                    return(
                        <IInput
                          title={val}
                          valid={valid}
                          readonly={activeReadonly}
                          value={String(temp)}
                          type={type}
                          onChangeHandler={onChangeHandler}
                        />
                    )
                   }else{
                    return;
                   }
                /* return (
                  <div className="text-center pb-2">
                    <Label className="text-capitalize">
                      {val.replace(/_/g, ' ').toLowerCase()}
                    </Label>
                    <ICreatableSelect
                      title={val}
                      values={valueEntities}
                      onChangeSelectHandler={onChangeSelectHandler}
                    />
                  </div>
                ); */
              default:
                type = 'text';
                break;
            }
            return (
              <IInput
                title={val}
                valid={valid}
                readonly={activeReadonly}
                value={String(temp)}
                type={type}
                onChangeHandler={onChangeHandler}
              />
            );
          })}
        </AvForm>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '1%',
          marginRight: '1%',
        }}
      >
        {renderButtons()}
      </div>
      <IPopUp
        stateAdd={popUpState}
        switchStateAdd={setpopUpState}
        modalTitleAdd={'Entity assignment'}
        icon="users"
        colorHeaderPop={'#101340'}
      >
        <FormUsersModal
          selectedEntities={valueEntities}
          onUpdateUser={ (data:any) => {
            onChangeSelectHandler( "SUB_ENTITIES", data )
          }}
          onCancel={onPopUpState}
        />
      </IPopUp>
    </>
  );
};

FormUsers.propTypes = {
  selectedRow: PropTypes.object,
  onCreateUser: PropTypes.func,
  onUpdateUser: PropTypes.func,
  onDeleteUser: PropTypes.func,
  onCancel: PropTypes.func,
};

export default FormUsers;
